@if (visible) {
    <div
        class="spinner"
        [class]="getSpinnerPositionClass()"
        [ngClass]="{ 'overlay-spinner': overlay, 'overlay-spinner-rounded': overlayRounded }"
        [ngStyle]="height && { height: height + 'px' }"
    >
        <span class="icon spinner-lg"></span>
        @if (infoText) {
            <div [translate]="infoText"></div>
        }
    </div>
}
